/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Shop All Hamburger Menu Toggle functionality with nested submenus
document.addEventListener('DOMContentLoaded', function() {
  const shopAllToggle = document.querySelector('[data-action="toggle-shop-all-menu"]');
  const shopAllMenu = document.getElementById('shop-all-menu');
  
  if (!shopAllToggle || !shopAllMenu) return;
  
  // Toggle the main Shop All menu
  shopAllToggle.addEventListener('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const isExpanded = shopAllToggle.getAttribute('aria-expanded') === 'true';
    
    // Toggle the menu
    shopAllToggle.setAttribute('aria-expanded', !isExpanded);
    shopAllMenu.setAttribute('aria-hidden', isExpanded);
    
    // Close other dropdowns if needed
    const allDropdowns = document.querySelectorAll('.shop-all-menu, .nav-dropdown, .popover');
    const allToggles = document.querySelectorAll('[aria-expanded="true"]');
    
    if (!isExpanded) {
      allDropdowns.forEach(dropdown => {
        if (dropdown !== shopAllMenu && dropdown.getAttribute('aria-hidden') === 'false') {
          dropdown.setAttribute('aria-hidden', 'true');
        }
      });
      
      allToggles.forEach(toggle => {
        if (toggle !== shopAllToggle) {
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });
  
  // Handle submenu toggles for items with dropdowns
  const shopAllLinks = shopAllMenu.querySelectorAll('.shop-all-menu__link');
  const shopAllSubLinks = shopAllMenu.querySelectorAll('.shop-all-menu__sub-link');
  
  // First level dropdown handling
  shopAllLinks.forEach(link => {
    if (link.hasAttribute('aria-controls')) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        
        const submenuId = link.getAttribute('aria-controls');
        const submenu = document.getElementById(submenuId);
        const isExpanded = link.getAttribute('aria-expanded') === 'true';
        
        // Toggle this submenu
        link.setAttribute('aria-expanded', !isExpanded);
        submenu.setAttribute('aria-hidden', isExpanded);
        
        // Close other submenus at this level
        const otherSubmenus = shopAllMenu.querySelectorAll('.shop-all-menu__sub-links');
        const otherLinks = shopAllMenu.querySelectorAll('.shop-all-menu__link[aria-expanded="true"]');
        
        otherSubmenus.forEach(menu => {
          if (menu.id !== submenuId) {
            menu.setAttribute('aria-hidden', 'true');
          }
        });
        
        otherLinks.forEach(otherLink => {
          if (otherLink !== link) {
            otherLink.setAttribute('aria-expanded', 'false');
          }
        });
      });
    }
  });
  
  // Second level dropdown handling
  shopAllSubLinks.forEach(link => {
    if (link.hasAttribute('aria-controls')) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        
        const submenuId = link.getAttribute('aria-controls');
        const submenu = document.getElementById(submenuId);
        const isExpanded = link.getAttribute('aria-expanded') === 'true';
        
        // Toggle this sub-submenu
        link.setAttribute('aria-expanded', !isExpanded);
        submenu.setAttribute('aria-hidden', isExpanded);
        
        // Close other sub-submenus at this level
        const parentSubmenu = link.closest('.shop-all-menu__sub-links');
        const otherSubSubmenus = parentSubmenu.querySelectorAll('.shop-all-menu__sub-sub-links');
        const otherSubLinks = parentSubmenu.querySelectorAll('.shop-all-menu__sub-link[aria-expanded="true"]');
        
        otherSubSubmenus.forEach(menu => {
          if (menu.id !== submenuId) {
            menu.setAttribute('aria-hidden', 'true');
          }
        });
        
        otherSubLinks.forEach(otherLink => {
          if (otherLink !== link) {
            otherLink.setAttribute('aria-expanded', 'false');
          }
        });
      });
    }
  });
  
  // Close when clicking outside
  document.addEventListener('click', function(event) {
    if (!shopAllToggle.contains(event.target) && !shopAllMenu.contains(event.target)) {
      // Close the main menu
      shopAllToggle.setAttribute('aria-expanded', 'false');
      shopAllMenu.setAttribute('aria-hidden', 'true');
      
      // Close all submenus
      const allExpandedLinks = shopAllMenu.querySelectorAll('[aria-expanded="true"]');
      const allOpenSubmenus = shopAllMenu.querySelectorAll('.shop-all-menu__sub-links[aria-hidden="false"], .shop-all-menu__sub-sub-links[aria-hidden="false"]');
      
      allExpandedLinks.forEach(link => {
        link.setAttribute('aria-expanded', 'false');
      });
      
      allOpenSubmenus.forEach(submenu => {
        submenu.setAttribute('aria-hidden', 'true');
      });
    }
  });
  
  // Close when pressing ESC
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      if (shopAllMenu.getAttribute('aria-hidden') === 'false') {
        // Close the main menu
        shopAllToggle.setAttribute('aria-expanded', 'false');
        shopAllMenu.setAttribute('aria-hidden', 'true');
        
        // Close all submenus
        const allExpandedLinks = shopAllMenu.querySelectorAll('[aria-expanded="true"]');
        const allOpenSubmenus = shopAllMenu.querySelectorAll('.shop-all-menu__sub-links[aria-hidden="false"], .shop-all-menu__sub-sub-links[aria-hidden="false"]');
        
        allExpandedLinks.forEach(link => {
          link.setAttribute('aria-expanded', 'false');
        });
        
        allOpenSubmenus.forEach(submenu => {
          submenu.setAttribute('aria-hidden', 'true');
        });
      }
    }
  });
  
  // Highlight active category based on current URL (optional)
  const currentPath = window.location.pathname;
  shopAllLinks.forEach(link => {
    if (link.getAttribute('href') === currentPath) {
      link.closest('.shop-all-menu__item').classList.add('is-active');
    }
  });
  
  shopAllSubLinks.forEach(link => {
    if (link.getAttribute('href') === currentPath) {
      link.closest('.shop-all-menu__sub-item').classList.add('is-active');
      // Also highlight parent
      const parentItem = link.closest('.shop-all-menu__sub-links').previousElementSibling;
      if (parentItem) {
        parentItem.closest('.shop-all-menu__item').classList.add('is-active');
      }
    }
  });
});
